import styled from "styled-components"
import { TextDiv, TextInput } from "../../common/Text"
import { useFormContext } from "react-hook-form"

const FirstNameInput = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <RelativeDiv>
      <TextInput
        $isError={errors.firstName ? true : false}
        placeholder="이름"
        {...register("firstName")}
      />
      {errors.firstName && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: 40,
          }}
        >
          * {errors.firstName.message?.toString()}
        </TextDiv>
      )}
    </RelativeDiv>
  )
}

export default FirstNameInput

const RelativeDiv = styled.div`
  position: relative;
`
